// media queries
export const mq = [
  window.matchMedia('(max-width: 767px)'),
  window.matchMedia('(min-width: 768px) and (max-width: 1279px)'),
  window.matchMedia('(min-width: 1280px)'),
];

export const timeoutDurationInstant = 0;
export const timeoutDurationStandard = 100;
export const timeoutDurationLonger = 200;
export const categoryQuickSearchDisplayLimit = 8;
export const categoryQuickSearchFetchLimit = 20;

export const KEY_ESCAPE = 'Escape';
export const KEY_ARROW_DOWN = 'ArrowDown';
export const KEY_ARROW_UP = 'ArrowUp';
